import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { Agent, AgentClient, DocumentTypeClient, DocumentTypes, TipAvaria, TipAvariaClient, Unit, VIKUnitClient } from "src/app/web-api-client";

@Component({
  selector: 'app-avarii-type-creation',
  templateUrl: './avarii-type-creation.component.html',
  styleUrls: ['./avarii-type-creation.component.scss']
})
export class TipAvariiCreationComponent implements OnInit  {

  public isLoaded = true;

   Form: FormGroup;

  public onClose = new Subject<boolean>();

  constructor(private fb: FormBuilder, public activeModal: NgbActiveModal, private toastr: ToastrService, public client:TipAvariaClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      isActive: [null, Validators.required]
    });
  }
  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service = new TipAvaria();

      service.id = 0;
      service.title = this.Form.value.title;
      service.isActive = this.Form.value.isActive;

      this.client.create(service).subscribe((user) => {

        this.toastr.success("Успешно Създаване", "", {
          timeOut: 3000,
          closeButton: true,
          positionClass: "toast-top-right",
        });

        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

}
